module.exports = __webpack_public_path__ + "img/gardening.be5030ca.webp";